


























import type { PropType } from '@nuxtjs/composition-api';
import { computed } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';
import VaimoButton from 'atoms/VaimoButton.vue';

import type { ProductTitleData } from '~/modules/catalog/product/types';

export default defineComponent({
  name: 'ProductSummary',
  components: {
    VaimoButton
  },
  props: {
    subtitle: {
      type: String,
      default: ''
    },
    productTitleData: {
      type: Object as PropType<ProductTitleData | null>,
      default: null
    },
    fallbackTitle: {
      type: String,
      default: ''
    },
    darkMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ['goToDescription'],
  setup(props) {
    const mainTitle = computed(() => {
      return props.productTitleData?.title || props.fallbackTitle;
    });
    return {
      mainTitle
    };
  }
});
